import { Ebbne, MountWithEbbne } from "@solidwhite/ebbnen";
import Section from "../Section";
import SubSection from "../SubSection";
import Brazing from "./Brazing";
import HardeningTempering from "./HardeningTempering";
import HowItWorks from "./HowItWorks";
import Welding from "./Welding";
import { Suspense } from "react";
import LoadingCallback from "../../LoadingCallback";

const HeatingApplications = ({ nodes }) => {
  return (
    <Ebbne id="applications">
      <group position={nodes.applications.position} rotation={nodes.applications.rotation}>
        <Section object3d={nodes.applications} />
      </group>

      <Ebbne id="bonding" visibleWithAbove={2}>
        <group position={nodes.applications.position} rotation={nodes.applications.rotation}>
          <SubSection object3d={nodes.bonding} />
        </group>
      </Ebbne>

      <Ebbne id="hardeningTempering" visibleWithAbove={2}>
        <group position={nodes.applications.position} rotation={nodes.applications.rotation}>
          <SubSection object3d={nodes.hardeningTempering} />
        </group>
        <MountWithEbbne mountedWhen={"active-and-below"}>
          <Suspense fallback={<LoadingCallback />}>
            <HardeningTempering />
          </Suspense>
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="welding" visibleWithAbove={2}>
        <group position={nodes.applications.position} rotation={nodes.applications.rotation}>
          <SubSection object3d={nodes.welding} />
        </group>
        <MountWithEbbne mountedWhen={"visible"}>
          <Welding />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="brazing" visibleWithAbove={2}>
        <group position={nodes.applications.position} rotation={nodes.applications.rotation}>
          <SubSection object3d={nodes.brazing} />
        </group>

        <MountWithEbbne mountedWhen="visible">
          <Brazing />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="howitworks" visibleWithAbove={2}>
        <group position={nodes.applications.position} rotation={nodes.applications.rotation}>
          <SubSection object3d={nodes.howitworks} />
        </group>

        <MountWithEbbne mountedWhen={"active-and-below"}>
          <HowItWorks />
        </MountWithEbbne>
      </Ebbne>
    </Ebbne>
  );
};

export default HeatingApplications;
